module.exports = __webpack_public_path__ + "static/img/rug_03.078d6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rug_03.png
// module id = 6o97
// module chunks = 17